import { z } from 'zod';


export const invoiceMaterialPositionSchema = z.object({
    id: z.number().default(-1),
    Invoice: z.number(),
    MaterialCategory: z.number().nullable().default(null),
    MaterialSubcategory: z.number().nullable().default(null),
    Material: z.number().nullable().default(null),
    Unit: z.number().default(6),

    title: z.string().default(""),
    description: z.string().default(""),
    units: z.number().default(0),
    price_per_unit: z.number().default(0),
})
export type IInvoiceMaterialPosition = z.infer<typeof invoiceMaterialPositionSchema>;